import React from 'react';
import ModalShell from '../ui/ModalShell';
import { proximosDias, diaCorto, diaLargo } from './diasRuta';

// Pasar uno o varios pedidos a la ruta de un día, o dejarlos sin día (23-oct-2026)
export default function ElegirDiaSheet({ titulo, subtitulo, actual = null, conSinDia = true, onElegir, onCerrar }) {
    const boton = 'h-16 rounded-xl inline-flex flex-col items-center justify-center active:scale-95';
    return (
        <ModalShell titulo={titulo} subtitulo={subtitulo} onCerrar={onCerrar}>
            <div className="space-y-3">
                <div className="grid grid-cols-3 gap-2">
                    {proximosDias().map(f => {
                        const c = diaCorto(f), es = actual && String(actual).slice(0, 10) === f;
                        return (
                            <button key={f} type="button" onClick={() => onElegir(f)} disabled={es}
                                className={`${boton} ${es ? 'bg-ink text-page' : 'bg-chip text-ink'}`} aria-label={diaLargo(f)}>
                                <span className="text-caption font-bold uppercase">{c.dia}</span>
                                <span className="text-body-lg font-black">{c.num}</span>
                            </button>
                        );
                    })}
                </div>
                {conSinDia && (
                    <button type="button" onClick={() => onElegir(null)} disabled={!actual}
                        className="w-full h-12 rounded-xl bg-chip text-secondary text-label font-black disabled:opacity-40">Sacar de la ruta (queda sin día)</button>
                )}
                <p className="text-caption text-muted px-1">Dispenser La Tienda confirma la ruta de cada día y te avisa.</p>
            </div>
        </ModalShell>
    );
}
